import React from 'react';
import { BellIcon, Trash2Icon } from 'lucide-react';
import { CompletionToggle } from '../ui/CompletionToggle';
import { formatFriendlyDeadline, isOverdue } from '../../utils/date';
import type { Task } from '../../types/task';
interface TaskItemProps {
  task: Task;
  onToggleComplete: () => void;
  onDelete?: () => void;
  compact?: boolean;
}
export function TaskItem({
  task,
  onToggleComplete,
  onDelete,
  compact = false
}: TaskItemProps) {
  const overdue = !task.completed && isOverdue(task.deadline);
  const deadlineLabel = formatFriendlyDeadline(task.deadline, true);
  return <div className="flex items-start gap-3 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" data-id="element-121" data-mp="2br198vbb0xsy">
      <CompletionToggle checked={task.completed} onChange={onToggleComplete} label={`Mark ${task.title} as complete`} colorClassName="bg-indigo-600 border-indigo-600" data-id="element-122" data-mp="2gisy91etavgz" />
      <div className="min-w-0 flex-1" data-id="element-123" data-mp="1o16w0cn2p786">
        <p className={`truncate text-sm font-medium ${task.completed ? 'text-slate-400 line-through' : 'text-slate-900'}`} data-id="element-124" data-mp="1o05nofxfyyu5">
          {task.title}
        </p>
        <div className="mt-1 flex items-center gap-2" data-id="element-125" data-mp="2sjzp1hr2piek">
          <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${task.completed ? 'bg-slate-100 text-slate-400' : overdue ? 'bg-red-50 text-red-600' : 'bg-indigo-50 text-indigo-600'}`} data-id="element-126" data-mp="2smlwzihvlzxb">
            {deadlineLabel}
          </span>
          {task.reminder && !task.completed && <BellIcon className="h-3.5 w-3.5 text-slate-400" data-id="element-127" data-mp="24uf2kovpo30j" />}
        </div>
      </div>
      {!compact && onDelete && <button type="button" onClick={onDelete} aria-label={`Delete ${task.title}`} className="text-slate-300 transition-colors duration-150 hover:text-red-500" data-id="element-128" data-mp="1zwdiq1qgnzo0">
          <Trash2Icon className="h-4 w-4" data-id="element-129" data-mp="3uawpigi1cpbu" />
        </button>}
    </div>;
}